import SpineWrapper from '@Core/Animation/SpineWrapper';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/GameScene/GameScene';
import { ELayeringOrder } from '@GFTypes/LayeringOrder';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

export class AboveReels extends GameComponent {
    static readonly SPINE_KEY: string = 'aboveReels';
    static readonly SKIN_NAME: string = 'default';
    public scene: GameScene;
    public spine: SpineWrapper;

    constructor(scene: GameScene) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, {
            source: LoggerSource.Game,
            message: 'AboveReels constructor'
        });
    }

    public onCreate(): void {
        this.spine = new SpineWrapper(
            this.scene,
            {
                x: this.scene.screen.width / 2,
                y: this.scene.screen.height / 2
            },
            { dataKey: AboveReels.SPINE_KEY, skinName: AboveReels.SKIN_NAME },
            true
        )!;

        this.spine.spine.zIndex = ELayeringOrder.ABOVE_REELS;
    }
}
